export default __webpack_public_path__ + "static/media/Slide2.96741583.jpg";